<template>
    <custom-search
        :label="label"
        :display-value="displayName"
        :disabled="!enabled"
        placeholder="Buscar Usuarios ..."
        :fetch-items="searchUsers"
        @select="onSelect"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
    >
        <template #item="{ item }">
            {{ item.firstName | cut(1) }}. {{ item.lastName | cut(30) }}
        </template>
    </custom-search>
</template>

<script>
import { mapActions, mapState } from "vuex";

import CustomSearch from "@/components/utils/CustomSearch.vue";

export default {
    name: "UserSearch",
    components: {
        CustomSearch
    },
    model: {
        prop: "itemCurrent",
        event: "input"
    },
    props: {
        defaultFilters: {
            default: () => ({}),
            type: Object,
            required: false
        },
        itemCurrent: {
            default: () => ({ id: "", firstName: "", lastName: "" }),
            type: Object,
            required: false
        },
        label: {
            default: () => "",
            type: String,
            required: false
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["blur", "focus", "input"],
    computed: {
        ...mapState("users", ["usersFilter"]),
        displayName() {
            return `${this.itemCurrent.firstName} ${this.itemCurrent.lastName}`.trim();
        }
    },
    methods: {
        ...mapActions("users", ["listAllUsers"]),
        async searchUsers(keyword, required = false) {
            await this.listAllUsers({
                ...this.defaultFilters,
                keyword,
                required
            });
            return this.usersFilter;
        },
        onSelect(item) {
            this.$emit("input", item);
        }
    }
};
</script>
